import { Box, HStack } from '@chakra-ui/react';
import * as React from 'react';

export const resourceListNameTdProps = {
  maxW: '0',
  w: 'full',
  overflow: 'hidden',
  py: 3,
} as const;

export const resourceListDateTdProps = {
  w: '36',
  whiteSpace: 'nowrap',
} as const;

export const resourceListNameTextProps = {
  minW: 0,
  w: 'full',
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
} as const;

type IResourceListNameProps = {
  icon: React.ReactNode;
  children: React.ReactNode;
  onClick?: () => void;
  cursor?: string;
};

export const ResourceListName = React.forwardRef<
  HTMLDivElement,
  IResourceListNameProps
>(({ icon, children, onClick, cursor }, ref) => {
  return (
    <HStack
      ref={ref}
      minW={0}
      w="full"
      align="flex-start"
      spacing={2}
      onClick={onClick}
      cursor={cursor}
    >
      <Box flexShrink={0}>{icon}</Box>
      <Box minW={0} flex="1">
        {children}
      </Box>
    </HStack>
  );
});

ResourceListName.displayName = 'ResourceListName';
